import { SupportedLanguages } from 'types/enums/LanguageType';

type LocaleConfig = {
  locale: string;
  currency: string;
};

const localeCurrencyMap: Record<SupportedLanguages, LocaleConfig> = {
  en: { locale: 'en-US', currency: 'USD' },
  es: { locale: 'es-AR', currency: 'ARS' },
  pt: { locale: 'pt-BR', currency: 'BRL' },
};

const parseAmounts = (value: number | string = 0, lang: SupportedLanguages = 'es'): string => {
  const numberValue = typeof value === 'string' ? parseFloat(value) : value;
  const { locale, currency } = localeCurrencyMap[lang] ?? localeCurrencyMap['es'];

  const newValue = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(numberValue);

  return newValue;
};

export default parseAmounts;
